import React from 'react';

const SortArrowIcon = ({
  isActive = false,
  direction = 'asc',
  className = '',
  size = { width: 8, height: 9 }
}) => {
  const rotation = isActive && direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)';
  const opacity = isActive ? '1' : '0.4';

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        transform: rotation,
        opacity: opacity,
        transition: 'transform 0.2s ease, opacity 0.2s ease'
      }}
    >
      <path
        d="M0.614904 3.82048C0.656878 3.87111 0.708429 3.91296 0.766602 3.94363C0.824776 3.97431 0.88843 3.99321 0.953918 3.99925C1.01941 4.00528 1.08544 3.99834 1.14824 3.97882C1.21105 3.9593 1.26938 3.92758 1.3199 3.88548L3.4999 2.07048V8.00048C3.4999 8.13309 3.55258 8.26026 3.64635 8.35403C3.74012 8.4478 3.8673 8.50048 3.9999 8.50048C4.13251 8.50048 4.25969 8.4478 4.35346 8.35403C4.44723 8.26026 4.4999 8.13309 4.4999 8.00048V2.07048L6.6799 3.88548C6.73046 3.9275 6.7888 3.95915 6.8516 3.97863C6.91439 3.99811 6.9804 4.00502 7.04587 3.99899C7.11133 3.99295 7.17497 3.97408 7.23314 3.94345C7.29131 3.91282 7.34288 3.87104 7.3849 3.82048C7.42693 3.76992 7.45858 3.71158 7.47806 3.64879C7.49753 3.58599 7.50445 3.51998 7.49841 3.45451C7.49238 3.38905 7.47351 3.32541 7.44288 3.26724C7.41225 3.20907 7.37046 3.1575 7.3199 3.11548L4.3199 0.615477L4.2449 0.570477L4.1799 0.535477C4.06407 0.490779 3.93574 0.490779 3.8199 0.535477L3.7549 0.570477L3.6799 0.615477L0.679904 3.11548C0.629275 3.15745 0.587423 3.209 0.556747 3.26718C0.526071 3.32535 0.507173 3.389 0.501135 3.45449C0.495097 3.51998 0.502038 3.58602 0.52156 3.64882C0.541083 3.71162 0.572803 3.76995 0.614904 3.82048Z" 
        fill="currentColor"
      />
    </svg>
  );
};

export default SortArrowIcon;
